// extracted by mini-css-extract-plugin
export default {"HeaderLevel1":"HeaderLevel1__HeaderLevel1___GAFN9","centered":"HeaderLevel1__centered___NS6Do"};